<template>
  <div class="pop" v-show="show" @click="close">
        <div style="display: inline-block;position: relative;" @click.stop="() => {}">
            <div class="close" @click="close"></div>
            <img :src="url" />
        </div>
  </div>
</template>

<script>
  // @ is an alias to /src

  export default {
    name: 'agree',
    data: () => ({
      show: true
    }),
    props: {
      url: {
        default: '',
        type: String
      },
    },
    methods: {
      close () {
        this.show = false
      }
    },
    components: {

    },
    mounted() {

    }
  }
</script>

<style scoped>
  .pop {
    position: fixed;
    z-index: 2000;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, .2);
    box-sizing: border-box;
    padding-top: 60px;
    text-align: center;
    overflow: auto;
    padding-bottom: 60px;
  }
  .close {
    background: url(../assets/image/example_close.png) no-repeat center;
    width: 16px;
    height: 15px;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 200;
    cursor: pointer;
  }
</style>